import Http from 'axios'
import {VERSIONED_API_URL} from '../../../config/config'

function initialState() {
    return {
        upgrade_data: {
            traveller: {},
            visa: {},
            plan_data: {},
            voucher_number: null,
            malanika_active: false,
            voucher_generated: false
        },
        tippaniContent: null,
        approveData: {},
        rejectData: {},
        is_verified: false
    }
}

const getters = {
    upgrade_data: state => state.upgrade_data
};

const actions = {
    async getPlanDetail({commit}, id) {
        try {
            const response = await Http.get(`${VERSIONED_API_URL}/plan-upgrade/${id}`);
            commit('setUpgradeData', response.data.data)
        } catch (e) {
            throw e;
        }
    },
    async verifyVisaUpgrade({state, dispatch, commit}) {
        try {
            await Http.post(`${VERSIONED_API_URL}/plan-upgrade/verify/${state.upgrade_data.id}`);
            dispatch('getPlanDetail', state.upgrade_data.id)
        } catch (e) {
            throw e;
        }
    },
    async saveTippani({state, commit}, data) {
        try {
            await Http.put(`${VERSIONED_API_URL}/plan-upgrade/${state.upgrade_data.id}`, {
                content: data
            })
            commit('setTippaniGenerated')
        } catch (e) {
            throw e;
        }
    },
    async generateVoucher({state, commit}) {
        try {
            const response = await Http.post(`${VERSIONED_API_URL}/generate-track-voucher/${state.upgrade_data.submission_no}?upgrade`)
            commit('setVoucherDetail', response.data)
        } catch (e) {
            throw e;
        }
    },
    async checkPaymentStatus({state, dispatch}) {
        try {
            const response = await Http.put(`${VERSIONED_API_URL}/plan-upgrade/payment-status/${state.upgrade_data.submission_no}`);
            dispatch('getPlanDetail', state.upgrade_data.id);
            return response.data;
        } catch (e) {
            throw e;
        }
    },
    async approveUpgrade({state, dispatch}) {
        try {
            const formData = new FormData();
            const files = state.approveData.files;
            if (files !== undefined) {
                for (let i = 0; i < files.length; i++) {
                    formData.append(`files[${i}]`, files[i]);
                }
            }
            formData.set('remarks', state.approveData.remarks);
            await Http.post(`${VERSIONED_API_URL}/plan-upgrade/approve/${state.upgrade_data.submission_no}`, formData);
            dispatch('getPlanDetail', state.upgrade_data.id);
        } catch (e) {
            throw e;
        }
    },
    async printPlanUpgrade({state, dispatch}) {
        try {
            await Http.post(`${VERSIONED_API_URL}/plan-upgrade/print/${state.upgrade_data.submission_no}`);
            dispatch('getPlanDetail', state.upgrade_data.id);
        } catch (e) {
            throw e;
        }
    },
    async rejectUpgrade({state, dispatch}) {
        try {
            const formData = new FormData();
            const files = state.rejectData.files;
            if (state.rejectData.files !== undefined) {
                for (let i = 0; i < files.length; i++) {
                    formData.append(`files[${i}]`, files[i]);
                }
            }
            formData.set('remarks', state.rejectData.remarks);
            await Http.post(`${VERSIONED_API_URL}/plan-upgrade/reject/${state.upgrade_data.submission_no}`, formData);
            dispatch('getPlanDetail', state.upgrade_data.id);
        } catch (e) {
            throw e;
        }
    }
};

const mutations = {
        setUpgradeData(state, detail) {
            state.upgrade_data = detail;
        },
        setVerified(state) {
            state.is_verified = true;
        },
        setVoucherDetail(state, data) {
            const update_data = JSON.parse(JSON.stringify(state.upgrade_data));
            update_data.voucher_number = data.data.voucher_number;
            update_data.malanika_active = data.data.malanika_active;
            update_data.voucher_generated = true;
            state.upgrade_data = update_data;
        },
        setTippaniGenerated(state) {
            state.upgrade_data.tippani_generated = true;
        },
        setPlanUpgradeTippaniContent(state, tippani) {
            state.tippaniContent = tippani;
        },
    }
;

export default {
    namespaced: true,
    state: initialState,
    getters,
    actions,
    mutations
}
